import Vue from "vue";

import { Button, Sticky, Search, Icon, ActionSheet, Popup, DatetimePicker, NavBar, Tab, Tabs, Popover, List, Collapse, CollapseItem, Image as VanImage, Loading, Empty, Lazyload, Toast, Swipe, SwipeItem, Checkbox, CheckboxGroup, Pagination, Circle, Divider, Dialog, Stepper,Rate } from "vant";

Vue.use(Button);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(Icon);
Vue.use(ActionSheet);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popover);
Vue.use(List);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Empty);
Vue.use(Lazyload);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Pagination);
Vue.use(Circle);
Vue.use(Divider);
Vue.use(Dialog);
Vue.use(Stepper);
Vue.use(Rate);
